import React from "react";
import {BsStarFill,BsStar} from "react-icons/bs"; 
import COLORS from "../styles/COLORS";

export default (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;  
  //console.log('from fav  ',cellValue)
  var isFav = cellValue==='Y'?true:false
  
  return (
    <div>
            {/* {( isFav) && <BsStarFill className='reicn' style ={{marginBottom: '7px', color: '#DAA520'}}/>}
           {( !isFav)  &&<BsStar className='reicn' style ={{marginBottom: '7px', color: '#DAA520'}}/>} */}

           {( isFav) && <BsStarFill color={props.isDisabled ? COLORS.disabledGrey : '#DAA520'} className='reicn' style ={{marginBottom: '2px'}}/>}
           {( !isFav)  &&<BsStar color={props.isDisabled ? COLORS.disabledGrey : '#DAA520'} className='reicn' style ={{marginBottom: '2px'}}/>}
  </div>
  );
};